/**
 * Provides an interface for modifying the list of fields associated with a `Layer`.
 * ## Fields
 * Name | Description
 * --- | ---
 * fields | The collection of `Field` models associated with the form.
 * @module app/views/dataType/DataFieldSetEditor
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
import Field from "core/models/Field";
import DataFieldEditor from "app/views/layer/DataFieldEditor";
import FieldTypes from "core/models/FieldTypes";
export default Backbone.View.extend({
  template: _.template('<li class="question-action"></li>'),
  tagName: "ul",
  className: "questions data-field-set-editor",

  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {app/models/FieldCollection} options.fields The collection of `Field` models to associate with this view.
   */
  initialize: function (options) {
    this.options = options;

    this.fields = this.options.fields;
    this._initSortable();
  },

  _initSortable: function () {
    this.$el.sortable({
      items: "> .question-item",
      placeholder: "sortable-placeholder well",
      cursor: "move",
      stop: _.bind(function () {
        var self = this;
        var position = 0;

        this.$(".question-item").each(function () {
          var questionId = $(this).attr("id"),
            model;

          if (self.fields && self.fields.models) {
            model = _.find(self.fields.models, function (field) {
              return field.cid == questionId;
            });
          }

          if (model) {
            model.set("position", position);
            position++;
          }
        });

        this.fields.sort();
      }, this),
      forcePlaceholderSize: true,
    });
  },

  render: function () {
    this.$el.html(this.template(this.options));

    this.listenTo(this.fields, "add", function (field) {
      this._appendQuestion(field).focus();
    });

    this.listenTo(this.fields, "remove", function (field) {
      this.$("#" + field.cid).remove();

      if (!this.fields.length) {
        this._lastField.focus();
      }
    });

    _.each(
      this.fields.models,
      function (model) {
        this._appendQuestion(model);
      },
      this
    );

    if (!this._lastField) {
      this._lastField = this._createLastField();
    }
  },

  /**
   * Adds the last question control to this container. This control is constantly existent to support addition of new fields.
   * @private
   * @return {Backbone.View} The view that was added.
   */
  _createLastField: function () {
    var model = new Field(
      {
        type: FieldTypes.Text,
        editable: true,
      },
      {
        parse: true,
      }
    );
    var view = this._appendQuestion(model, {
      canRemove: false,
    });

    model.on(
      "change:label",
      function () {
        if (model.get("label")) {
          model.set("position", this.fields.models.length); //make sure it gets sorted to the end of the list
          this.fields.add(_.omit(_.clone(model.attributes), "id", "position"));
        }

        model.set("label", "");
        view.$(".field-text input").val(""); //todo pull a FormInputView from the view to do this instead.
      },
      this
    );

    return view;
  },

  _appendQuestion: function (model, options) {
    model.set(
      "position",
      _.isNumber(model.get("position"))
        ? model.get("position")
        : this.fields.length - 1
    );

    var result = new DataFieldEditor(
      _.extend(
        {
          fields: this.fields,
          model: model,
        },
        options
      )
    );

    result.$el.attr("id", model.cid);

    result.render();
    this._append(result.$el);
    this._initSortable();

    return result;
  },

  _append: function (item) {
    if (this._lastField) {
      this._lastField.$el.before(item);
    } else {
      this.$(".question-action").before(item);
    }
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layer/FieldSetEditor.js
// module id = 885
// module chunks = 1